export default __webpack_public_path__ + "static/media/IconDesc_Gift.256.5332a76d.png";